import { on, onOneOf } from '$router/config'
import React from 'react'
import { GLOBAL_SETTING_SIDE_MENUS } from '$layouts/LayoutWithSidebar/constants'
import LayoutWithSidebar from '$layouts/LayoutWithSidebar'
import { GLOBAL_SETTING_ROUTES } from './constants'
import { usePermissions } from '$hooks/actions'

const GlobalSettingRoutes = () => {
  const isGlobalSettingRoutes = onOneOf(GLOBAL_SETTING_ROUTES.map(v => v.name))

  const { checkPermissions } = usePermissions()

  if (!isGlobalSettingRoutes) return null

  return (
    <LayoutWithSidebar
      menus={GLOBAL_SETTING_SIDE_MENUS.map(m => ({
        ...m,
        menus: m.menus.filter(mm => checkPermissions(mm.permissions))
      }))}
    >
      {GLOBAL_SETTING_ROUTES.map(
        ({ name, Component }) =>
          on(name) && <React.Fragment key={name}>{Component}</React.Fragment>
      )}
    </LayoutWithSidebar>
  )
}

export default GlobalSettingRoutes
